import { render } from "./DevicesListScreen.vue?vue&type=template&id=12f5b5bc"
import script from "./DevicesListScreen.vue?vue&type=script&lang=js"
export * from "./DevicesListScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__